module.exports = __webpack_public_path__ + "static/media/mining.217111f0.png";